import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserImportLog } from '../model/userImportLog';
import { UpdateLogRequest } from '../model/updateLogStateRequest';
import { UserImportLogService } from '../services/userimportlog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { LogDialogComponent } from './log-dialog.component';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LogHelperComponent  {

  private userImportLogList: UserImportLog[];
  private readonly lastImportLogSubject: BehaviorSubject<UserImportLog> = new BehaviorSubject(undefined);
  private readonly unhandledLogsSubject: BehaviorSubject<number> = new BehaviorSubject(0);

  private dialogRef;
  public unhandledLogs = this.unhandledLogsSubject.asObservable();
  public lastImportLog = this.lastImportLogSubject.asObservable();

  constructor(
    private readonly dialog: MatDialog,
    private readonly userImportLogService: UserImportLogService,
    private readonly toastrService: ToastrService) {

    this.userImportLogService.userImportLogs.subscribe(
      (fetchedLogs) => {
        if (fetchedLogs.length > 0) {
          this.userImportLogList = fetchedLogs;
          let unhandledLogs = this.userImportLogList.filter(
            hl => !hl.resolved
          ).length

          this.unhandledLogsSubject.next(unhandledLogs);

        }
      }
    );

    this.userImportLogService.lastImportLog.subscribe((log) => {
      this.lastImportLogSubject.next(log);
    });

  }

  public openImportLogDialog() {
    const dialogConfig = this.getLogDialogConfig();

    let self = this;

    dialogConfig.data = {
      'logs': this.userImportLogList,
      'title': 'Import loggar',
      'onResolveItems': function (updatedItems: UpdateLogRequest[]) {
        updatedItems.forEach((log) => {
          self.userImportLogService.updateImportLogResolvedState(log)
            .then(() => {
              self.toastrService.success("Logg uppdaterad");
              self.dialogRef.close(false);
            })
            .catch((error: HttpErrorResponse) => {
              const message = error.error?.errors?.Comment?.join(', ');
              const title = error?.error?.title;
              self.toastrService.error(title + " " + message, "Fel vid uppdatering av logg")
            });
        });
      }

    };

    this.showDialog(dialogConfig, () => { });
  }

  private showDialog(config: MatDialogConfig, onCloseFunction) {
    this.dialogRef = this.dialog.open(LogDialogComponent, config);

    this.dialogRef.afterClosed().subscribe(result => {
      if (onCloseFunction)
        onCloseFunction(result);
    });
  }

  private getLogDialogConfig(): MatDialogConfig {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.width = '800px';
    dialogConfig.height = '630px';
    dialogConfig.maxHeight = '630px';
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = 'dialogPanel';
    dialogConfig.closeOnNavigation = false;
    return dialogConfig;
  }
}
